import React, { useState, useEffect } from 'react';

import { api } from '../../../services/api';
import { session } from '../../../services/session';

import { Loader, NoResult } from '../../misc/loader-utils';
import { Columns } from '../../base/megatable/column-service';
import StatTable from '../../base/megatable/stat-table';
import ReportDropdown from '../../base/dropdowns/report-dropdown';

import linkoutIcon from '../../../images/icons/linkout.svg';
import './top-five-table.scss';

const pubColumns = new Columns().Top5PubsFields;
const storyColumns = new Columns().top5StoriesFields;

function TopFiveTable({ strategyId, merchId, type, dateRange }) {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNoResult, setShowNoResult] = useState(false);
  const endpoint =
    type === 'stories'
      ? `/api/v0/merchants/${merchId}/strategies/${strategyId}/stories_performance/`
      : `/api/v0/merchants/${merchId}/strategies/${strategyId}/pubs_performance/`;
  const statType = type === 'stories' ? 'top-five-stories' : 'top-five-pubs';

  useEffect(() => {
    setLoading(true);
    const params = getParams();

    api
      .get(endpoint, params)
      .then(resp => {
        const { stats } = resp.data.data[0];

        setStats(stats);
        setShowNoResult(!stats.length);
        setLoading(false);
      })
      .catch(() => {
        setShowNoResult(true);
        setLoading(false);
      });
  }, [dateRange, strategyId]);

  function getParams() {
    return {
      page: 1,
      per_page: 5,
      strategy_id: parseInt(strategyId),
      date_from: dateRange.startDate.format('YYYY-MM-DD'),
      date_to: dateRange.endDate.format('YYYY-MM-DD'),
    };
  }

  function formatColumn(columnObj, props) {
    const { data } = props;

    if (columnObj.name === 'story_name') {
      return (
        <div className="column story_name" key={`story_name-${data.link_out}`}>
          <p>
            <span>{data.story_name}</span>
            <a className="link-out" href={data.story_url} target="_blank" rel="noopener noreferrer">
              <img src={linkoutIcon} alt="link out" />
            </a>
          </p>
        </div>
      );
    }

    if (columnObj.name === 'roi') {
      return (
        <div className="column roi" key={`roi-${data.roi}`}>
          <p>{parseFloat(data.roi).toFixed(1)}</p>
        </div>
      );
    }
    return null;
  }

  const table =
    !loading && !showNoResult ? (
      <StatTable
        stats={stats}
        totals={[]}
        columns={type === 'stories' ? storyColumns : pubColumns}
        sortDisabledFields={[]}
        statType={`top-five-${type}`}
        tableName=""
        sortOptions={{}}
        disableEditUrl={true}
        showTotals={false}
        updateSortParams={() => {}}
        history={[]}
        match={{}}
        location=""
        classOverride="base-search-table overview-table"
        columnFormatter={formatColumn}
      ></StatTable>
    ) : null;

  const header = (
    <div className="header">
      <div className="title">
        {type === 'stories' ? 'Top 5 Revenue Driving Stories' : 'Top 5 Revenue Driving Publishers'}
      </div>
      <ReportDropdown
        statType={statType}
        orgId={merchId}
        gaEvent={{
          category: 'Top Five Table',
          label: `${statType} Export Data`,
        }}
        queryParams={getParams()}
        columns={type === 'stories' ? storyColumns : pubColumns}
        currentPage={1}
        perPage={5}
        rowCounts={{ visible: stats.length }}
        disabled={loading}
        reportOptionsOverride={[{ label: 'Visible', value: 'visible' }]}
        reportVersion="V2"
      />
    </div>
  );

  return (
    <div className="top-five-table">
      {header}
      {table}
      <Loader loading={loading} />
      <NoResult noResult={showNoResult} type="strategy-performance" />
    </div>
  );
}

export default TopFiveTable;
